module.exports = __webpack_public_path__ + "static/simona1-77c7cf3fcd9630247e02acc1ba1d5ff8.jpg";